import React from "react";
import { useLocation } from "react-router-dom";
import "./PageTransition.css";

/** Fades in the page content on each route change instead of an abrupt swap. */
function PageTransition({ children }) {
    const location = useLocation();

    return (
        <div key={location.pathname} className="tw-page-transition">
            {children}
        </div>
    );
}

export default PageTransition;
